export default "__VITE_ASSET__bE6HxwA1__"